import { forwardRef } from 'react';

import cn from 'classnames';

import { CandidateDetailsForm } from 'components/CandidateDetailsForm/CandidateDetailsForm';
import { Button } from 'components/FormComponents';
import { StepHeader } from 'components/StepHeader/StepHeader';

import styles from './Step1Form.module.scss';

export const Step1Form = forwardRef(({ onClick = () => {}, ...props }, ref) => (
  <div className={cn(styles.root)}>
    <div className={cn('card', 'card-with-border')}>
      <StepHeader step={1} title="Enter Candidate Details" subtitle="Fill out the details below" />
      <div className={cn('background-secondary', 'u-padding', 'card_border--top')}>
        <CandidateDetailsForm ref={ref} {...props} className="u-margin-top u-width-100" />
      </div>
      <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-between')}>
        <Button type="secondary">Cancel</Button>
        <Button dataTestId="next-button" onClick={onClick}>
          Next
        </Button>
      </div>
    </div>
  </div>
));
